import template from './component.tpl.html';
import TicketTemplatePreviewController from './controller';

angular.module('festzelt-os.modules.tickets.templates')
    .component('alTicketTemplatePreview', {
        bindings: {
            previewData: '<'
        },
        controller: TicketTemplatePreviewController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/components/al-ticket-template-preview/component.js